"use client";

import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import * as React from "react";

import { cn } from "@/lib/utils";

const ToggleGroup = ToggleGroupPrimitive.Root;

const ToggleItem = React.forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.ToggleGroupItem>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.ToggleGroupItem>
>(({ className, ...props }, ref) => (
  <ToggleGroupPrimitive.ToggleGroupItem
    ref={ref}
    className={cn(
      "px-3 py-1.5 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border-solid bg-[#F1F5F9] data-[state=on]:bg-[#CBD5E1] first:rounded-l-sm last:rounded-r-sm",
      className
    )}
    {...props}
  />
));
ToggleItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleItem };
